import moment from "moment";
import DateMomentUtil from "../../../../../app/util/DateMomentUtil";
import InputValidationStateBo from "../../../../../form/input/InputValidationStateBo";
import InputValidator from "../../../../../form/input/InputValidator";
import InputValidatorI from "../../../../../form/input/InputValidatorI";

export default class InputVsBeginnValidator implements InputValidatorI {

    private value?: string;

    constructor(newValue?: string) {
        this.value = newValue;
    }

    validate(): InputValidationStateBo {
        // *** exist value
        if (InputValidator.isBlank(this.value)) {
            return InputValidationStateBo.createInValid("Wählen Sie bitte den Vertragsbeginn.");
        }
        // *** Handelt es sich um ein Datum
        if (!InputValidator.isDate(this.value)) {
            return InputValidationStateBo.createInValid("Wählen Sie bitte den Vertragsbeginn.");
        }

        // *** Das Datum darf nicht in der Vergangenheit liegen
        if (!InputValidator.isDateSameOrAfterNow(this.value)) {
            return InputValidationStateBo.createInValid("Ein Beginn in der Vergangenheit ist nicht möglich.");
        }

        // *** Max. zwei Jahre im Voraus
        const nextYear = DateMomentUtil.formatLocalDate(DateMomentUtil.addYears(moment(), 2));

        if (InputValidator.isDateSameOrAfter(this.value, nextYear)) {
            return InputValidationStateBo.createInValid("Der Vertragsbeginn darf maximal 2 Jahre im Voraus liegen.");
        }

        // *** Wert is gueltig!
        return InputValidationStateBo.createValid()
    }

}